import React, { useState } from 'react';
import MyInput from './UI/input/MyInput';
import MyButton from './UI/button/MyButton';
// import MyInput from './components/UI/input/MyInput';
// import MyButton from './components/UI/button/MyButton';

const PostForm = ({create}) => {
    const [post, setPost] = useState({ title: '', body: '' });
    const addNewPost = (e) => {
        e.preventDefault();
        // console.log(`new post: ${post.title} - ${body}`);
        const newPost = {
            ...post, id:Date.now()
        }
        create(newPost);
        setPost({title: '', body: ''});
    }
    return (
        <form>
            <MyInput
                value={post.title}
                onChange={e => setPost({ ...post, title: e.target.value })}
                type='text'
                placeholder="Название поста"
            />
            <MyInput
                value={post.body}
                onChange={e => setPost({ ...post, body: e.target.value })}
                type='text'
                placeholder="22222222"
            />
            <MyButton onClick={addNewPost}>Create Post</MyButton>
        </form>
    )
}

export default PostForm